/*============================================================================
  Product
==============================================================================*/
var selectCallback = function (variant, selector) {
  $('.swatch-element').on('click', function(){
    $(this).parent().find('.option_title').html('COLOR - ' + $(this).attr('data-value') );
  });
  
  let $product;
  $product = $(`.product-${selector.product.id}`);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');

  // Notify form

  const $notify_form = $(`.notify-form-${selector.product.id}`);
  const productTitle = $notify_form.data('product-title');
  const $notifyFormInputs = $('.notify_form__inputs', $product);
  const notifySend = window.PXUTheme.translation.notify_email_send;
  const notifyUrl = $notifyFormInputs.data('url');

  // Construct the notify message
  if (variant) {
    if (variant.title !== 'Default Title') {
      // Escape the variant title
      window.variantTitle = variant.title.replace(/"/g, '&quot;');
      window.notifyMessage = window.PXUTheme.translation.notify_message_first + productTitle + ' - ' + window.variantTitle + window.PXUTheme.translation.notify_message_last + notifyUrl;
    } else {
      window.notifyMessage = window.PXUTheme.translation.notify_message_first + productTitle + window.PXUTheme.translation.notify_message_last + notifyUrl;
    }
  }

  // Prefill the email address if a customer is logged in
  let notifyFormEmail;
  let notifyFormPlaceholder;
  if ($notify_form.hasClass('notify-form--customer')) {
    notifyFormEmail = $notify_form.data('customer-email');
    notifyFormPlaceholder = '';
  } else {
    notifyFormEmail = '';
    notifyFormPlaceholder = window.PXUTheme.translation.notify_email;
  }

  // Compile HTML
  window.notifyFormHTML = `
    <input
      class="notify-email"
      id="contact[email]"
      name="contact[email]"
      type="email"
      placeholder="${notifyFormPlaceholder}"
      value="${notifyFormEmail}"
      required
    >

    <input
      type="hidden"
      name="challenge"
      value="false"
    >

    <input
      class="notify_form_message"
      name="contact[body]"
      type="hidden"
      data-body="${window.notifyMessage}"
      value="${window.notifyMessage}"
    >

    <input
      class="
        global-button
        global-button--primary
      "
      type="submit"
      value="${notifySend}"
    >
  `;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.js-product-gallery', $product);
    $sliders.each((_, slider) => {
      const $slider = $(slider);
      const $sliderInstance = window.Flickity.data($slider[0]);
      if ($slider && $sliderInstance !== undefined) {
        const index = $(`[data-image-id="${variant.featured_media.id}"]`).data('index');
        $sliderInstance.select(index, false, true);
      }
    });
  }

  // Toggles images in product slider when inline quickshop and layout set to slider
  if (variant && variant.featured_image && $product.is(':visible')) {
    if (window.PXUTheme.theme_settings.product_form_style === 'select' && window.PXUTheme.theme_settings.quick_shop_style === 'inline') {
      const $selectedVariants = $('.products-slider').find('select option:not(.selector-wrapper select option)').filter(':selected');
      $selectedVariants.each(function toggleImage() {
        if ($(this).data('featured-image')) {
          console.log("IF IF IF");
          const swatchImage = $(this).data('image');
          const $quickShopElement = $(this).parents('.thumbnail').find('.image__container img');
          $quickShopElement.attr('src', swatchImage);
          $quickShopElement.attr('srcset', swatchImage);
        }
      });
    }
  }
  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(v => {
        if (v.id === variant.id) {
          const currentVariant = variant;
          currentVariant.inventory_quantity = v.inventory_quantity;
          currentVariant.inventory_management = v.inventory_management;
          currentVariant.inventory_policy = v.inventory_policy;
        }
      });
    }
    $('.sku span', $product).text(variant.sku);
    if (window.PXUTheme.theme_settings.product_form_style === 'swatches') {
      const {
        length
      } = variant.options;
      for (let i = 0; i < length; i++) {
        const radioButton = $productForm.find(`.swatch[data-option-index="${escape(i)}"] :radio[value="${variant.options[i].replace(/"/g, '\\"')}"]`);
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    } else {
      $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${window.variantTitle}`);
    }
  }
  /** Customization for disabling sold out options starts **/

  function setFirstAvailableVariant(firstAvailableVariant) {
    $('.single-option-selector[data-option="option3"] option').each(function () {
      var currentOption = $(this);
      if (!currentOption.attr("disabled")) {
        $('.single-option-selector[data-option="option3"]').val(currentOption.val());
        return false;
      }
    });

    if (firstAvailableVariant != $(".multi_select").val()) {
      $('.single-option-selector[data-option="option3"]').trigger("change");
    } 
  }  
  
  //keep track of which variant selector was clicked/changed
  //only set option3 (Size/Type) to first available if it was not
  //the variant that was changed
  //setFirstAvailableVariant() function used below with a timeOut of 500 in order to accomplish this
  var colorOrFinishClicked = true;
  $(".swatch-element").click(function () {
    colorOrFinishClicked = true;
  });
  
  $('.single-option-selector[data-option="option2"]').change(function () {
    colorOrFinishClicked = true;
  });
    
  $('.single-option-selector[data-option="option3"]').change(function () {
    colorOrFinishClicked = false;
  });
  
  function updateAvailability(v1, v2, v3) {
    console.log('173');
    //go through first dropdown if you see color + first dropdown you good go through second dropdown
    var vColor = v1;
    var vFinish = v2;
    var vSize = v3;
    $('.single-option-selector[data-option="option3"] option').each(function() {
      $(this).attr('disabled', true);
    });

    $('.single-option-selector[data-option="option2"] option').each(function() {
      var select = $(this);
      var searchOption = vColor + ' / ' + $(this).attr('value');
      $('.variant-library-container .variant-value').each(function() {
        if ($(this).attr('data-value').indexOf(searchOption) != -1) {
          select.attr('disabled', false);
          return false;
        } else {
          select.attr('disabled', true);
        }
      });
    });

    var firstAvailableVariant = '';

    $('.single-option-selector[data-option="option2"] option').each(function() {
      var vFinish2 = $(this).attr('value');

      $('.single-option-selector[data-option="option3"] option').each(function() {
        var select = $(this);
        var searchOption = vColor + ' / ' + vFinish2 + ' / ' + $(this).attr('value');

        var stop = false;
        $('.variant-library-container .variant-value').each(function() {
          var currentLibraryItem = $(this).attr('data-value');
          var currentLibraryItemID = $(this).attr('data-id');
          var currentLibraryItemArray = currentLibraryItem.split(" / ");
          var currentLibraryColor = currentLibraryItemArray[0].trim();
          var currentLibraryFinish = currentLibraryItemArray[1].trim();
          var currentLibrarySize = currentLibraryItemArray[2].trim();

          if (!stop) {
            if (currentLibraryColor == vColor && currentLibraryFinish == vFinish &&
              currentLibraryItem.indexOf(searchOption) != -1) {
              select.attr("disabled", false);
              if (firstAvailableVariant == '') firstAvailableVariant = currentLibraryItemID;
            }
          }
        });
      });
    });
  }

  if (variant && variant.available == true) {
    console.log(variant);
    console.log('226');
    if (variant.price < variant.compare_at_price) {
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + ' / ' + variant.barcode + '</span>');
      $('.savings', $product).html(window.PXUTheme.translation.savings_text + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      console.log(window.PXUTheme.theme_settings.display_inventory_left);
      console.log('239');
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        if (variant.inventory_quantity == 1) {
          items_left_text = window.PXUTheme.translation.one_item_left;
        } else {
          items_left_text = window.PXUTheme.translation.items_left_text;
        }

        var inventoryThreshold = parseInt(window.PXUTheme.theme_settings.inventory_threshold);
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(variant.inventory_quantity + " " + items_left_text);
        } else {
          $('.items_left', $product).html("");
        }
      }
      if (window.PXUTheme.theme_settings.limit_quantity) {
        if (variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    if (variant.price > 0) {
      console.log('266');
      var price_per_sf = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('price-per-sf');
      var price_sell_unit = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('price-sell-unit');
      var variant_price = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('price');
      var carton_sf = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('carton-sf');
      var unit_measure = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('unit-measure');
      var uom_duom = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('uom-duom');
      var cstm_uom = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-oum');
      if (typeof unit_measure !== 'undefined' || unit_measure == null || carton_sf !== 'undefined' || carton_sf == null) {
        $("#v-price").html("(PURCHASE BY " + price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + "/" + price_sell_unit + ")");
        if (price_sell_unit != unit_measure) {
          $("#v-price").html("(PURCHASE BY " + price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + "/" + price_sell_unit + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>)");
        }
      }

      var test_sqft = $('#v-price .cstm-uom-dom-content').text();
      if (test_sqft.includes("SF")) {
        $('#v-price .cstm-uom-dom-content').text(" sq. ft");
      };

      var test_sheet = $('#v-price .cstm-uom-dom-content').text();
      if (test_sqft.includes("SHEET")) {
        $('#v-price .cstm-uom-dom-content').text(" sheets");
      };

      var test_sheet = $('#v-price .cstm-uom-dom-content').text();
      if (test_sqft.includes("PIECE")) {
        $('#v-price .cstm-uom-dom-content').text(" piece");
      };
      var test_sheet = $('#v-price .cstm-uom-dom-content').text();
      if (test_sqft.includes("EACH")) {
        $('#v-price .cstm-uom-dom-content').text(" each");
      };

      if (meta.product.type == "Accessories") {
        $('.current_price', $product).removeClass('sold_out').html('<span class="money">$' + (parseFloat(variant.price) / 100).toFixed(2) + '</span>');
      } else {
        $('.current_price', $product).removeClass('sold_out').html('<span class="money">$' + parseFloat(price_per_sf).toFixed(2) + ' / ' + unit_measure + '</span>');
      }
    } else {
      $('.current_price', $product).removeClass('sold_out').html(window.PXUTheme.theme_settings.free_text);
    }

    updateAvailability(variant.option1, variant.option2, variant.option3);
    console.log('310');
    //updates SKU in Product Details section
    var variant_leadtime = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-leadtime');
    var variant_available = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-availability');
    var so_description = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-so-description');
    var price_sell_unit = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('price-sell-unit');
    var available_to_promise = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-available-to-promise');
    var cstm_uom = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-oum');
    var unit_measure = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('unit-measure');
    var carton_sf = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('carton-sf');
    var variant_price = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('price');
    var variant_product_type = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('variant-product-type');
    var variant_inventory_qty = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('inventory-qty');


    if (variant_available == 'Special Order') {
      $("#_specialOrder").val('true');
    } else {
      $("#_specialOrder").val('false');
    }
      // IF PURCHASE BY CARTON
      console.log(price_sell_unit);
      if (price_sell_unit == 'CARTON') {
          if (unit_measure == 'PIECE') {
              $('#product_details_variant_sku').text(variant.sku);
              if (variant_available == 'Stock') {
                  if (available_to_promise > 1) {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + unit_measure + 'S' + ' ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + unit_measure + ' ' + 'available)');
                  }
              } else {
                  $('#product_variant_availability').text(variant_available);
              }
              $('#product_variant_leadtime').text(variant_leadtime);
              $('#product_details_variant_description').text(so_description);

              if (typeof unit_measure !== 'undefined' || unit_measure == null || carton_sf !== 'undefined' || carton_sf == null) {
                  if (variant_price == 0.00) {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                  } else {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
                  }
                  if (price_sell_unit != unit_measure) {
                      if (cstm_uom == 0.0) {
                          if (variant_price == 0.00) {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                          } else {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
                          }
                      } else if (price_sell_unit == unit_measure) {
                          if (variant_price == 0.00) {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                          } else {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
                          }
                      } else {
                          if (variant_price == 0.00) {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                          } else {
                              if (unit_measure == 'SF') {
                                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + 'sq ft.' + "</span>");
                              } else {
                                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>");
                              }
                          }
                      }
                  }
              }

              $('#product_variant_product_type').text(variant_product_type);

          } else {
              $('#product_details_variant_sku').text(variant.sku);
              if (variant_available == 'Stock') {
                  if (available_to_promise > 1) {
                      if (price_sell_unit == 'SF') {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                      } else if (price_sell_unit == 'EACH') {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'units ' + 'available)');
                      } else if (price_sell_unit == 'PC') {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'pieces ' + 'available)');
                      } else {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + 'S ' + 'available)');
                      }
                  } else {
                      if (price_sell_unit == 'SF') {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                      } else if (price_sell_unit == 'EACH') {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'unit ' + 'available)');
                      } else if (price_sell_unit == 'PC') {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'piece ' + 'available)');
                      } else {
                          $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + ' ' + 'available)');
                      }
                  }
              }
              // ==================================
              else if(variant_available == 'Discontinued' && variant_inventory_qty > 0 ){
                      if(available_to_promise > 1){
                          $('#product_variant_availability').text(variant_available +', (' + available_to_promise +' '+ price_sell_unit +'S'+' '+ 'available)'); 
                        } else{
                      $('#product_variant_availability').text(variant_available +', (' + available_to_promise +' '+ price_sell_unit +' '+ 'available)'); 
                        }
                      }
              // ===============================
              else {
                  $('#product_variant_availability').text(variant_available);
              }
              $('#product_variant_leadtime').text(variant_leadtime);
              $('#product_details_variant_description').text(so_description);

              if (typeof unit_measure !== 'undefined' || unit_measure == null || carton_sf !== 'undefined' || carton_sf == null) {
                  if (variant_price == 0.00) {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                  } else {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
                  }
                  if (price_sell_unit != unit_measure) {
                      if (cstm_uom == 0.0) {
                          if (variant_price == 0.00) {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                          } else {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
                          }
                      } else if (price_sell_unit == unit_measure) {
                          if (variant_price == 0.00) {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                          } else {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
                          }
                      } else {
                          if (variant_price == 0.00) {
                              $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
                          } else {
                              if (unit_measure == 'SF') {
                                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + 'sq ft.' + "</span>");
                              } else {
                                  if (cstm_uom > 1) {

                                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + 'S' + "</span>");
                                  } else {
                                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>");
                                  }

                              }
                          }
                      }
                  }
              }

              $('#product_variant_product_type').text(variant_product_type);

          }
      }
      // END PURCHASE BY CARTON
      // IF PURCHASE BY SHEET
      else if (price_sell_unit == 'SHEET') {
          $('#product_details_variant_sku').text(variant.sku);
          if (variant_available == 'Stock') {
              if (available_to_promise > 1) {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'units ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'pieces ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit.toLowerCase() + 's ' + 'available)');
                  }
              } else {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'unit ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'piece ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + ' ' + 'available)');
                  }
              }
          } else {
              $('#product_variant_availability').text(variant_available);
          }
          $('#product_variant_leadtime').text(variant_leadtime);
          $('#product_details_variant_description').text(so_description);
          if (cstm_uom == 0.0) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else if (price_sell_unit == unit_measure) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  if (unit_measure == 'SF') {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + 'sq ft.' + "</span>");
                  } else {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>");
                  }
              }
          }

          $('#product_variant_product_type').text(variant_product_type);
      }
      // END PURCHASE BY SHEET
      // IF PURCHASE AND PRICE BY PIECE
      else if (price_sell_unit == 'PIECE' || price_sell_unit == 'EACH') {
          $('#product_details_variant_sku').text(variant.sku);
          if (variant_available == 'Stock') {
              if (available_to_promise > 1) {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'units ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'pieces ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit.toLowerCase() + 's ' + 'available)');
                  }
              } else {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'unit ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'piece ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + ' ' + 'available)');
                  }
              }
          } else {
              $('#product_variant_availability').text(variant_available);
          }
          $('#product_variant_leadtime').text(variant_leadtime);
          $('#product_details_variant_description').text(so_description);
          if (cstm_uom == 0.0) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else if (price_sell_unit == unit_measure) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  if (unit_measure == 'SF') {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + 'sq ft.' + "</span>");
                  } else {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>");
                  }
              }
          }


          $('#product_variant_product_type').text(variant_product_type);
      }
      // END PURCHASE AND PRICE BY PIECE

      // IF PURCHASE BY PALLET
      else if (price_sell_unit == 'PALLET') {
          $('#product_details_variant_sku').text(variant.sku);
          if (variant_available == 'Stock') {
              if (available_to_promise > 1) {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'units ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'pieces ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + 'S ' + 'available)');
                  }
              } else {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'unit ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'piece ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + ' ' + 'available)');
                  }
              }
          } else {
              $('#product_variant_availability').text(variant_available);
          }
          $('#product_variant_leadtime').text(variant_leadtime);
          $('#product_details_variant_description').text(so_description);
          if (cstm_uom == 0.0) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else if (price_sell_unit == unit_measure) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  if (unit_measure == 'SF') {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + 'sq ft.' + "</span>");
                  } else {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>");
                  }
              }
          }

          // $('.modal_price .price__container .sale-price-area .current_price span.money').text('$' + price_per_sf + '/' + price_sell_unit);
          $('#product_variant_product_type').text(variant_product_type);
      }
      // END PURCHASE BY PALLET

      // ELSE CASE
      else {
          $('#product_details_variant_sku').text(variant.sku);
          if (variant_available == 'Stock') {
              if (available_to_promise > 1) {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'units ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'pieces ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + 'S ' + 'available)');
                  }
              } else {
                  if (price_sell_unit == 'SF') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'sq ft.' + ' ' + 'available)');
                  } else if (price_sell_unit == 'EACH') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'unit ' + 'available)');
                  } else if (price_sell_unit == 'PC') {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + 'piece ' + 'available)');
                  } else {
                      $('#product_variant_availability').text(variant_available + ', (' + available_to_promise + ' ' + price_sell_unit + ' ' + 'available)');
                  }
              }
          } else {
              $('#product_variant_availability').text(variant_available);
          }
          $('#product_variant_leadtime').text(variant_leadtime);
          $('#product_details_variant_description').text(so_description);
          if (cstm_uom == 0.0) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else if (price_sell_unit == unit_measure) {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + price_per_sf);
              }
          } else {
              if (variant_price == 0.00) {
                  $("#product_variant_purchase_unit").html(price_sell_unit + " - Inquire for Price");
              } else {
                  if (unit_measure == 'SF') {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + 'sq ft.' + "</span>");
                  } else {
                      $("#product_variant_purchase_unit").html(price_sell_unit + " - $" + (parseFloat(variant.price) / 100).toFixed(2) + ", " + cstm_uom + " <span class='cstm-uom-dom-content'>" + unit_measure + "</span>");
                  }
              }
          }


          $('#product_variant_product_type').text(variant_product_type);
      }

      console.log('693');
      // END ELSE CASE
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $('.shopify-payment-button', $product).removeClass('disabled');
      $('.purchase-details__buttons', $product).removeClass('product-is-unavailable');
      $('.modal_price', $product).removeClass('variant-unavailable');
      $notify_form.hide();
      $notifyFormInputs.empty();
  } else {
    console.log("693");
      // When product is sold out
      var message = variant ? window.PXUTheme.theme_settings.sold_out_text : window.PXUTheme.translation.unavailable_text;

      if (variant) {

          updateAvailability(variant.option1, variant.option2, variant.option3);

          // Adds correct price
          if (variant.price > 0) {
              var price_per_sf = $('.variant-library-container').find('[data-id=' + variant.id + ']').data('price-per-sf');
              if (meta.product.type == "Accessories") {
                  $('.current_price', $product).removeClass('sold_out').html('<span class="money">$' + variant.price / 100 + '</span>');
              } else {
                  $('.current_price', $product).removeClass('sold_out').html('<span class="money">$' + price_per_sf + ' / ' + unit_measure + '</span>');
              }
          } else {
              $('.current_price', $product).html(window.PXUTheme.theme_settings.free_text);
          }
          if (window.PXUTheme.theme_settings.display_sold_out_price) {
              $('.current_price', $product).parents('.price__container--display-price-true').addClass('has-margin-right');
          }
          $('.modal_price', $product).removeClass('variant-unavailable');
      } else {
          var newVariant = '';
          $('.variant-library-container .variant-value').each(function() {

              var arrLibraryVariant = $(this).attr('data-value').split(' / ');

              if (arrLibraryVariant[0].trim() == $('.swatch_options input:checked+.swatch-element').attr('value')) {
                  newVariant = $(this).attr('data-value');

                  // if the Finish of current library variant and the selected Finish match, return false
                  if ($('.single-option-selector[data-option="option2"]').val() == arrLibraryVariant[1].trim()) return false;
              }
          });


          if (newVariant) {
              newVariant = newVariant.split(' / ');
              var newColor = newVariant[0].trim();
              var newFinish = newVariant[1].trim();
              var newSize = newVariant[2].trim();

              if (newVariant.length > 3) newSize = newSize + ' / ' + newVariant[3].trim();

              $('.single-option-selector option').each(function() {

                  $(this).attr('disabled', false);
              });

              //update option2 selector
              $('.single-option-selector[data-option="option2"]').val(newFinish);

              //update option3 selector
              //(perry) commented this out for now.. was causing issues
              updateAvailability(newColor, newFinish, newSize);
              $('.single-option-selector[data-option="option2"] option[value="' + newFinish + '"]').attr('disabled', false);
              $('.single-option-selector[data-option="option3"] option[value="' + newSize + '"]').attr('disabled', false);
          } else {}
          // Add class to quickshop so we know variant is unavailable
          $('.modal_price', $product).addClass('variant-unavailable');
          $('.current_price', $product).html('');
          $('.was_price', $product).html('');
          $('.savings', $product).html('');
          $('.current_price', $product).parents('.price__container--display-price-true').removeClass('has-margin-right');
      }

      // If show price setting disabled, hide price, compare at price and savings
      /*
  if (!window.PXUTheme.theme_settings.display_sold_out_price){
    $('.current_price', $product).html('');
    $('.was_price', $product).html('');
    $('.savings', $product).html('');
  }

  $('.items_left', $product).text('');
  $('.quantity', $product).removeAttr('max');
  $('.sold_out', $product).text(message);
  $('.purchase-details__buttons', $product).addClass('product-is-unavailable');
  $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
  $('.shopify-payment-button').addClass('disabled');
  $notify_form.hide();
  $notifyFormInputs.empty();
*/
      if (variant && !variant.available) {
          $notify_form.fadeIn();
          $notifyFormInputs.empty();
          $notifyFormInputs.append(notifyFormHTML);
      }
  }
  /** Customization for disabling sold out options Ends **/
  if (variant && variant.available === true) {
    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        if (variant.inventory_quantity === 1) {
          window.itemsLeftText = window.PXUTheme.translation.one_item_left;
        } else {
          window.itemsLeftText = window.PXUTheme.translation.items_left_text;
        }
        const inventoryThreshold = parseInt(window.PXUTheme.theme_settings.inventory_threshold, 10);
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variant.inventory_quantity} ${window.itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (window.PXUTheme.theme_settings.limit_quantity) {
        if (variant.inventory_policy === 'deny') {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }
    $('.sold_out', $product).text('');
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).removeClass('disabled');
    $('.purchase-details__buttons', $product).removeClass('product-is-unavailable');
    $('.modal_price', $product).removeClass('variant-unavailable');
    $product.find($notify_form).hide();
    $product.find($notifyFormInputs).empty();
  } else {
    // When product is sold out
    const message = variant ? window.PXUTheme.translation.sold_out_text : window.PXUTheme.translation.unavailable_text;
    if (variant) {
      $('.modal_price', $product).removeClass('variant-unavailable');
    } else {
      // Add class to quickshop so we know variant is unavailable
      $('.modal_price', $product).addClass('variant-unavailable');
    }
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.purchase-details__buttons', $product).addClass('product-is-unavailable');
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    $('.shopify-payment-button', $product).addClass('disabled');
    $notify_form.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(window.notifyFormHTML);
    }
  }
  if (window.PXUTheme.currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
};

window.productPage = {
  loadQuickshop(url) {
    return window.shopifyAsyncview.load(url,
    // Template name
    {
      view: 'quickshop'
    } // View name (suffix)
    );
  },

  init() {
    window.Shopify.loadFeatures([{
      name: 'shopify-xr',
      version: '1.0'
    }, {
      name: 'model-viewer-ui',
      version: '1.0'
    }], window.productMedia.setupMedia);

    // Call enable gallery function for product galleries
    $('[data-product-gallery]:not(.product-recommendations [data-product-gallery])').each(function () {
      const $productGallery = $(this);
      window.productPage.enableGallery($productGallery);
    });
    if (window.location.search === '?contact_posted=true') {
      $('.notify-form .contact-form').hide();
      $('.notify-form .contact-form').prev('.message').html(window.PXUTheme.translation.notify_success_text);
    }
    if (window.PXUTheme.theme_settings.product_form_style === 'swatches') {
      $('body').on('change', '.swatch :radio', function swatchLogic() {
        const optionIndex = $(this).closest('.swatch').attr('data-option-index');
        const optionValue = $(this).val();
        const parentForm = $(this).closest('.product_form form');
        let notifyForm;
        if (parentForm.siblings('.notify-form').length) {
          window.notifyForm = parentForm.siblings('.notify-form');
        } else {
          window.notifyForm = $('.js-notify-form');
        }
        const option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        const option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        const option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';
        let notifyMessage;
        if (option1 && option2 && option3) {
          window.notifyMessage = `${option1} / ${option2} / ${option3}`;
        } else if (option1 && option2) {
          window.notifyMessage = `${option1} / ${option2}`;
        } else {
          window.notifyMessage = option1;
        }
        window.notifyForm.find('.notify_form_message').attr('value', `${window.notifyForm.find('.notify_form_message').data('body')} - ${window.notifyMessage}`);
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
      });
    }
    $('.js-product-gallery a').fancybox({
      width: 800,
      height: 800,
      baseClass: 'product-section__lightbox',
      clickContent: false,
      afterShow(instance) {
        // Loop through fancybox images, add alt attributes
        const fancyImages = $('.fancybox-image');
        $('.product-gallery__image').each((index, image) => {
          const $image = $(image);
          const alt = $image.attr('alt');
          fancyImages.eq(index).attr('alt', alt);
        });
        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom) {
          $('.fancybox-image').last().wrap('<span class="zoom-wrap" style="display:inline-block"></span>').css('display', 'block').parent().zoom({
            touch: false,
            magnify: 1
          });
        }
      },
      afterClose(instance) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(() => {
          $instanceGallery.fadeIn(100);
          $('.js-product-gallery').find('.is-selected a').focus();
        }, 1);
      }
    });
    const recipientFormEl = document.querySelector('[data-recipient-form]');
    if (recipientFormEl) {
      const sectionEl = recipientFormEl.closest('.product_section');
      this.recipientForm = new RecipientForm(sectionEl);
    }

    // Complementary products
    const complementaryProductsEl = document.querySelector('[data-complementary-products]');
    if (complementaryProductsEl) {
      const sectionEl = complementaryProductsEl.closest('.product_section');
      const {
        sectionId,
        productId,
        productRecommendationLimit
      } = JSON.parse(document.querySelector('[data-complementary-products-data]').textContent);
      this.complementaryProductRecommendations = new ComplementaryProducts({
        sectionEl,
        sectionId,
        productId,
        productRecommendationsRoute: window.PXUTheme.routes.product_recommendations_url,
        includeIndicatorDots: true,
        limit: productRecommendationLimit,
        arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z'
      });
    }

    /** Customizations for Multiple Options */

    $('.js-product_section .product_form_options').each(function () {
      // Enable selectCallback if the number of select elements is not equal to the options size data
      if ($(this).find('.selector-wrapper select').length != $(this).data('options-size')) {
        new Shopify.OptionSelectors($(this).data('select-id'), { product: $(this).data('product'), onVariantSelected: selectCallback, enableHistoryState: $(this).data('enable-state') });
      }
    });

    /** Customizations for Multiple Options Ends */

    /*
      If the product recommendations section exists, run the loadProductRecommendations method
      The selectCallback within this method will only affect the products in the product recommendations section
    */
    if ($('.shopify-section--recommended-products').length) {
      window.productPage.loadProductRecommendations();
    }
  },
  runOptionSelector($element) {
    let $defaultSelector = $('.js-product-section [data-product-form]:not(.product-recommendations .js-product-section [data-product-form])');
    if ($element) {
      $defaultSelector = $element.find('[data-product-form]');
    }
    $defaultSelector.each((_, options) => {
      const $options = $(options);
      const $productDetails = $options.closest('.product__details');

      // Set up variables for price ui and surface pickup
      let priceUIEl;
      const paymentTerms = new window.PaymentTerms($productDetails[0]);

      // If smaller screen size and thumbnail hover enabled
      // use price ui element inside of caption instead
      if (window.PXUTheme.media_queries.medium.matches && window.PXUTheme.theme_settings.hover_enabled && window.PXUTheme.theme_settings.quick_shop_enabled && window.PXUTheme.theme_settings.quick_shop_style === 'inline') {
        priceUIEl = $productDetails.find('.modal_price [data-price-ui], .product-info__caption [data-price-ui]')[0];
      } else {
        priceUIEl = $productDetails.find('[data-price-ui]')[0];
      }
      const priceUIBadgeEl = $productDetails.find('[data-price-ui-badge]')[0];
      const surfacePickUpEl = $productDetails.find('[data-surface-pick-up]')[0];
      const JSONData = $options.data('product');
      const isPriceSavingsEnabled = priceUIEl && priceUIEl.closest(['[data-display-savings="true"]']);
      const productTitle = $options.data('product-title');
      let priceUI;
      let priceUIBadge;
      let surfacePickUp;
      let currentVariant;
      if (priceUIEl) {
        priceUI = new window.ShopifyPriceUI.PriceUI(priceUIEl);
      }
      if (priceUIBadgeEl) {
        priceUIBadge = new window.ShopifyPriceUI.PriceUIBadge(priceUIBadgeEl);
      }
      if (surfacePickUpEl) {
        surfacePickUp = new window.ShopifySurfacePickUp(surfacePickUpEl);
        surfacePickUp.onModalRequest(contents => {
          const surfacePickUpModal = document.querySelector('[data-surface-pick-up-modal]');
          let fragment;
          if (currentVariant.title && productTitle) {
            fragment = document.createDocumentFragment();
            const header = document.createElement('div');
            const title = document.createElement('h2');
            header.classList.add('surface-pick-up__modal-header');
            title.classList.add('surface-pick-up__modal-title');
            title.innerHTML = productTitle;
            header.appendChild(title);
            if (currentVariant.title !== 'Default Title') {
              const subtitle = document.createElement('span');
              subtitle.classList.add('surface-pick-up__modal-subtitle');
              subtitle.innerHTML = currentVariant.title;
              header.appendChild(subtitle);
            }
            fragment.appendChild(header);
          }
          surfacePickUpModal.innerHTML = contents;
          surfacePickUpModal.insertBefore(fragment, surfacePickUpModal.firstChild);
          $.fancybox.open(surfacePickUpModal, {
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            }
          });
        });
      }
      new window.Shopify.OptionSelectors($options.data('select-id'), {
        product: $options.data('product'),
        onVariantSelected: (variant, selector) => {
          currentVariant = variant;
          paymentTerms.update(variant ? variant.id : null);
          if (priceUI) {
            priceUI.load(JSONData, {
              variant,
              formatter: price => window.Shopify.formatMoney(price, $('body').data('money-format')),
              handler: (priceUIFragment, _product, _ref) => {
                let {
                  variant: v
                } = _ref;
                if (isPriceSavingsEnabled && v) {
                  if (v.compare_at_price > v.price) {
                    const span = document.createElement('span');
                    span.classList.add('sale', 'savings');
                    const savings = v.compare_at_price - v.price;
                    const percentage = Math.round(savings / v.compare_at_price * 100);
                    span.innerHTML = `${window.PXUTheme.translation.savings_text} ${percentage}% (<span class="money">${window.Shopify.formatMoney(v.compare_at_price - v.price, $('body').data('money-format'))}</span>)`;
                    priceUIFragment.appendChild(span);
                  }
                }
                if (v && v.available) {
                  if (v.price === 0) {
                    const fragment = document.createDocumentFragment();
                    const span = document.createElement('span');
                    span.classList.add('free-price-text');
                    if (window.PXUTheme.theme_settings.free_text !== '') {
                      span.innerHTML = window.PXUTheme.theme_settings.free_text;
                    } else {
                      span.innerHTML = `<span class="money">${window.Shopify.formatMoney(v.price, $('body').data('money-format'))}</span>`;
                    }
                    fragment.appendChild(span);
                    return fragment;
                  }
                  return priceUIFragment;
                }
                if (!window.PXUTheme.theme_settings.display_sold_out_price) {
                  const fragment = document.createDocumentFragment();
                  const soldOutText = document.createElement('span');
                  soldOutText.classList.add('sold_out');
                  soldOutText.innerHTML = v ? window.PXUTheme.translation.sold_out_text : window.PXUTheme.translation.unavailable_text;
                  fragment.appendChild(soldOutText);
                  return fragment;
                }

                // Displays sold out text beside price
                if (window.PXUTheme.theme_settings.display_sold_out_price) {
                  const span = document.createElement('span');
                  span.classList.add('sold_out');
                  span.innerHTML = v ? window.PXUTheme.translation.sold_out_text : window.PXUTheme.translation.unavailable_text;
                  priceUIFragment.appendChild(span);
                }
                return priceUIFragment;
              }
            });
            if (window.PXUTheme.theme_settings.display_sold_out_price && variant && variant.price === 0 && !variant.available) {
              const priceElement = priceUIEl.querySelector('[data-price]');
              if (!priceElement) {
                return;
              }
              if (window.PXUTheme.theme_settings.free_text !== '') {
                const span = document.createElement('span');
                span.classList.add('free-price-text');
                span.innerHTML = window.PXUTheme.theme_settings.free_text;
                priceElement.innerHTML = '';
                priceElement.appendChild(span);
              } else if (window.PXUTheme.theme_settings.free_text === '') {
                priceElement.classList.add('price--sale');
                return;
              }
            }
          }
          if (priceUIBadge) {
            priceUIBadge.load(JSONData, {
              variant,
              style: 'default',
              formatter: price => window.Shopify.formatMoney(price, $('body').data('money-format')),
              handler: (priceUIFragment, _product, _ref2) => {
                let {
                  variant: v
                } = _ref2;
                if (v && v.available) {
                  if (!v.compare_at_price || v.compare_at_price <= v.price) {
                    return document.createDocumentFragment();
                  }
                  return priceUIFragment;
                }
                if (v && !v.available || !v) {
                  const fragment = document.createDocumentFragment();
                  let text;
                  const sticker = document.createElement('div');
                  sticker.classList.add('price-ui-badge__sticker');
                  const stickerText = document.createElement('span');
                  stickerText.classList.add('price-ui-badge__sticker-text');
                  stickerText.setAttribute('data-badge', '');
                  if (v && !v.available) {
                    sticker.classList.add('price-ui-badge__sticker--sold-out');
                    text = window.PXUTheme.translation.sold_out_text;
                  }
                  if (!v) {
                    sticker.classList.add('price-ui-badge__sticker--unavailable');
                    text = window.PXUTheme.translation.unavailable_text;
                  }
                  stickerText.innerHTML = text;
                  sticker.appendChild(stickerText);
                  fragment.appendChild(sticker);
                  return fragment;
                }
                return priceUIFragment;
              }
            });
          }

          // Avoid loading surface pickup for the inline quick shop
          if (surfacePickUp && !$options.closest('.js-product-section').hasClass('inline-quickshop')) {
            surfacePickUp.load(variant ? variant.id : null);
          }
          window.selectCallback(variant, selector, $element);
        },
        enableHistoryState: $options.data('enable-state')
      });
    });
  },
  enableGallery(selector) {
    // Variables
    const $productGallery = $(selector);
    const $slides = $productGallery.find('.gallery-cell');
    const $thumbnailProductGallery = $productGallery.closest('.js-product-section').find('.product_gallery_nav');
    const $thumbnails = $thumbnailProductGallery.find('.gallery-cell');
    const zoom = $productGallery.data('zoom');
    const productLightbox = $productGallery.data('product-lightbox');
    const thumbnailsEnabled = $productGallery.data('thumbnails-enabled');
    const thumbnailsSliderEnabled = $productGallery.data('thumbnails-slider-enabled');
    const thumbnailsPosition = $productGallery.data('thumbnails-position');
    const thumbnailsArrows = $productGallery.data('gallery-arrows-enabled');
    const slideshowSpeed = $productGallery.data('slideshow-speed');

    // If zoom enabled
    if (zoom === true) {
      if (window.is_touch_device() && window.PXUTheme.media_queries.medium.matches) {
        // Lightbox has a built-in zoom feature, so check if lightbox is disabled
        if (productLightbox === 'false') {
          document.addEventListener('lazybeforeunveil', window.imageFunctions.zoom);
        }
      } else {
        document.addEventListener('lazybeforeunveil', window.imageFunctions.zoom);
        window.imageFunctions.zoom($productGallery.find('[data-zoom-src]').first());
      }
    }
    $productGallery.on('ready.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        let videoID;
        switch (mediaType) {
          case 'external_video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');
            if (window.videoPlayers) {
              window.videoPlayers.forEach(player => {
                const currentPlayer = player;
                if (player.id === videoID || player.media.id === videoID) {
                  if (!$(slide).hasClass('is-selected')) {
                    currentPlayer.keyboard = {
                      focused: false,
                      global: false
                    };
                  }
                }
              });
            }
            break;
          case 'video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');
            if (window.videoPlayers) {
              window.videoPlayers.forEach(player => {
                const currentPlayer = player;
                if (player.id === videoID || player.media.id === videoID) {
                  if (!$(slide).hasClass('is-selected')) {
                    currentPlayer.keyboard = {
                      focused: false,
                      global: false
                    };
                  }
                }
              });
            }
            break;
          case 'model':
            if ($(slide).hasClass('is-selected')) {
              // When active slide
              if (mediaType === 'model' && window.isScreenSizeLarge()) {
                $(slide).on('mouseenter', () => {
                  $productGallery.flickity('unbindDrag');
                });
                $(slide).on('mouseleave', () => {
                  $productGallery.flickity('bindDrag');
                });
              }
            }
            break;
          default:
            break;
        }
      });

      // Video looping
      const loopingEnabled = $productGallery.data('video-loop');
      $.each(window.videoPlayers, (index, player) => {
        const videoPlayer = player;
        videoPlayer.loop = loopingEnabled;
      });
    });
    $productGallery.on('change.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type of current slide
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        if ($(slide).hasClass('is-selected')) {
          // When active slide
          switch (mediaType) {
            case 'model':
              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */

              if (window.isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', () => {
                  $productGallery.flickity('unbindDrag');
                });

                // On mouseleave event, bind flickity
                $(slide).on('mouseleave', () => {
                  $productGallery.flickity('bindDrag');
                });
              }

              // Listen for model pause/play events
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', () => {
                $productGallery.flickity('unbindDrag');
              });
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', () => {
                $productGallery.flickity('bindDrag');
              });
              break;
            default:
              $productGallery.flickity('bindDrag');
              break;
          }
        } else {
          // When inactive slide
          switch (mediaType) {
            case 'external_video':
              // Youtube video pausing
              $.each(window.videoPlayers, (_index, player) => {
                player.pause();
              });
              break;
            case 'video':
              // HTML5 video pausing
              $.each(window.videoPlayers, (_index, player) => {
                player.pause();
              });
              break;
            default:
              break;
          }
        }
      });

      // Restore 3d model icons
      window.productMedia.showModelIcon($productGallery);
    });
    $productGallery.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1,
      autoPlay: slideshowSpeed * 1000,
      watchCSS: false
    });

    // Adjust arrows height if controls are hidden/shown
    $.each(window.videoPlayers, (index, player) => {
      // When controls are hidden, height should be auto
      player.on('controlshidden', () => {
        $productGallery.find('.flickity-prev-next-button').css('height', 'auto');
      });
      // When controls are shown, height should account for controls bar
      player.on('controlsshown', () => {
        $productGallery.find('.flickity-prev-next-button').css('height', 'calc(100% - 64px)');
      });
    });
    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(window.videoPlayers, (index, player) => {
        if (parseInt(player.media.dataset.plyrVideoId, 10) === videoID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }
    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(window.videoPlayers, (index, player) => {
        if (player.playing) {
          player.pause();
        }
        if (player.media.id === iframeID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }
    function checkForVideos() {
      $slides.each((index, slide) => {
        // Variables
        const $slide = $(slide);
        const mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        let videoID = $slide.find('video').data('plyr-video-id');
        const $iframeVideo = $slide.find('iframe');
        const iframeID = $iframeVideo.attr('id');
        if ($slide.hasClass('is-selected')) {
          if (mediaType === 'video') {
            videoID = $slide.find('video').data('plyr-video-id');
            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType === 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile
    const $sliderArrows = $productGallery.find('.flickity-prev-next-button');
    if (($sliderArrows || $thumbnails) && window.isScreenSizeLarge()) {
      $sliderArrows.on('click', () => {
        const pId = $productGallery.data('product-id');
        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, model => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });
            $.each(sortedModels, model => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.on('click', event => {
        const index = $(event.currentTarget).index();
        const pId = $productGallery.data('product-id');
        $productGallery.flickity('select', index);
        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, (_index, model) => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });
            $.each(sortedModels, (_index, model) => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.keypress(event => {
        const index = $(event.currentTarget).index();
        const pId = $productGallery.data('product-id');
        if (event.which === 13) {
          $productGallery.flickity('select', index);
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          $productGallery.on('settle.flickity', () => {
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $productGallery.off('settle.flickity');
          });

          // Find out media type of featured media slide
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, model => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });
            $.each(sortedModels, model => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          return false;
        }
        return undefined;
      });
    }

    // Thumbnail gallery logic begins
    if (thumbnailsEnabled === true && thumbnailsSliderEnabled === true && $slides.length > 1) {
      // If desktop determine which slider we build
      if (window.PXUTheme.media_queries.large.matches) {
        // If thumbnail position is left/right then vertical slider gets enabled
        if (thumbnailsPosition === 'left' || thumbnailsPosition === 'right') {
          $thumbnailProductGallery.css('max-height', $productGallery.closest('.product-gallery').outerHeight());
          $thumbnailProductGallery.addClass('vertical-slider-enabled');
          $thumbnails.on('click', event => {
            const index = $(event.currentTarget).index();
            $productGallery.flickity('select', index);
          });
          const navCellHeight = $thumbnails.height();
          const navHeight = $thumbnailProductGallery.height();
          $productGallery.on('select.flickity', () => {
            // set selected nav cell
            const flkty = $productGallery.data('flickity');
            $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');
            const $selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected');

            // scroll nav
            const scrollY = $selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
            $thumbnailProductGallery.animate({
              scrollTop: scrollY
            });
          });
        } else {
          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $thumbnails.length > 5 ? thumbnailsArrows : false,
            asNavFor: $productGallery[0]
          });
          $thumbnailProductGallery.on('settle.flickity', () => {
            $thumbnailProductGallery.flickity('resize');
          });
          $(window).on('load', () => {
            $thumbnailProductGallery.flickity('resize');
          });

          // Once thumbnail is focused, move carousel to that cell
          $.each($thumbnails, (index, thumbnail) => {
            const $thumbnail = $(thumbnail);
            if ($thumbnail.hasClass('is-selected')) {
              $thumbnail.on('focus', () => {
                $thumbnailProductGallery.flickity('selectCell', index);
              });
            }
          });
        }
      } else {
        // If not on desktop, create standard thumbnail slider
        $thumbnailProductGallery.flickity({
          cellAlign: 'center',
          contain: true,
          groupCells: '80%',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: $thumbnails.length > 5 ? thumbnailsArrows : false,
          asNavFor: $productGallery[0]
        });
      }
    } else if (thumbnailsEnabled === true) {
      // If thumbnail slider is disabled, ensure thumbnails can still navigate product images
      $thumbnailProductGallery.find('.product-gallery__thumbnail').on('click', function () {
        const index = $(this).index();
        $productGallery.flickity('selectCell', index);
      });
    }
    $(window).on('load', () => {
      $productGallery.flickity().flickity('resize');
    });
    $productGallery.on('settle.flickity', () => {
      $productGallery.flickity().flickity('resize');
    });
  },
  loadProductRecommendations() {
    const $productRecommendations = $('[data-product-recommendations]');
    const $productRecommendationsSection = $('.shopify-section--recommended-products');
    const sectionID = $productRecommendations.data('section-id');
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');
    const recommendationsURL = $productRecommendations.data('recommendations-url');
    const sectionEnabled = $productRecommendationsSection.find($productRecommendations).data('enabled');
    const $recommendedProductSlider = $('.js-recommended-products-slider');
    function loadDynamicProducts() {
      // Build request URL
      const requestUrl = `${recommendationsURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

      // Make ajax call to request information for window.Shopify's recommended products
      $.ajax({
        type: 'GET',
        url: requestUrl,
        success(data) {
          if (!sectionEnabled) {
            return;
          }
          const $recommendedProductsElement = $(data).find('.product-recommendations').html();

          // Insert product list into the product recommendations container
          $productRecommendations.html($recommendedProductsElement);

          // Initialize product slider if it exists on page
          if ($recommendedProductSlider.length) {
            window.productPage.recommendedProductsSlider();
          } else {
            // Call enable gallery function for product galleries
            $('[data-product-recommendations] [data-product-gallery]').each((_, gallery) => {
              const $productGallery = $(gallery);
              window.productPage.enableGallery($productGallery);
            });
          }

          // Converting the currencies
          if (window.PXUTheme.currency.show_multiple_currencies) {
            window.currencyConverter.convertCurrencies();
          }

          // Run option selectors
          window.productPage.runOptionSelector($productRecommendationsSection);

          // Initialize shopify payment buttons
          if (window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          // Hide <noscript> elements
          window.hideNoScript();

          // Initialize video players
          window.videoFeature.setupRecommendedVideoPlayer();

          // Initialize swatch toggler
          $('.swatch_options label').on('click', function () {
            window.quickShop.toggleSwatchImages($(this));
          });

          // Initialize the show secondary media on hover feature
          if (window.PXUTheme.theme_settings.collection_secondary_image) {
            window.imageFunctions.showSecondaryImage();
          }
        }
      });
    }
    if (!sectionEnabled) {
      return;
    }

    // If meta collection, no need to run API request
    const metaCollection = $productRecommendations.hasClass('meta-related-recommended-collection');
    if (metaCollection) {
      // Takes care of moving content from Shopify section into block container

      // Initialize product slider if it exists on page
      if ($recommendedProductSlider.length) {
        window.productPage.recommendedProductsSlider();
      } else {
        // Call enable gallery function for product galleries
        $('.product-recommendations [data-product-gallery]').each(function () {
          const $productGallery = $(this);
          window.productPage.enableGallery($productGallery);
        });
      }

      // Run option selectors
      window.productPage.runOptionSelector($productRecommendationsSection);
    } else {
      loadDynamicProducts();
    }
  },
  productSwatches() {
    // Swatches linked with selected options
    if (window.PXUTheme.theme_settings.product_form_style === 'swatches') {
      if ($('.js-product-section').length) {
        console.log("JSJS");
        const $productForms = $('.js-product-section').find('.product_form');
        $productForms.addClass('is-visible');

        // Loop through each product and set the initial option value state

        $productForms.each((_, productForm) => {
          const $productForm = $(productForm);
          const JSONData = $productForm.data('product');
          const productID = $productForm.data('product-id');
          const productSection = `.product-${productID} .js-product-section`;
          const swatchOptions = $productForm.find('.swatch_options .swatch');
          console.log(swatchOptions);
          if (swatchOptions.length > 1) {
            console.log("IF nitesh");
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }

      // Add click event when there is more than one product on the page (eg. Collection in Detail)
      if ($('.js-product-section').length > 1) {
        $('body').on('click', '.swatch-element', swatchElement => {
          const $swatchElement = $(swatchElement.currentTarget);
          const swatchValue = $swatchElement.data('value').toString();
          $swatchElement.siblings(`input[value="${swatchValue.replace(/"/g, '\\"')}"]`).prop('checked', true).trigger('change');
          const JSONData = $swatchElement.parents('.product_form').data('product');
          const productID = $swatchElement.parents('.product_form').data('product-id');
          const productSection = `.product-${productID} .js-product-section`;
          const swatchOptions = $swatchElement.parents('.product_form').find('.swatch_options .swatch');
          console.log(swatchOptions);
          if (swatchOptions.length > 1) {
            console.log('else nitesh');
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }
    }
  },
  recommendedProductsSlider() {
    $('.product-recommendations .products-slider').each((_, productSlider) => {
      const $productSlider = $(productSlider);
      const productsPerSlide = $productSlider.data('products-per-slide');
      const productsLimit = $productSlider.data('products-limit');
      const productsAvailable = $productSlider.data('products-available');
      let cellAlign;
      let draggable;
      let prevNext;
      let wrapAround;
      let initialIndex;
      const lessSlidesThanProducts = productsAvailable > productsPerSlide;
      const limitGreaterThanSlide = productsLimit > productsPerSlide;
      const evenSlide = productsPerSlide % 2 === 0;
      if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
        cellAlign = 'left';
      } else {
        cellAlign = 'center';
      }
      if (lessSlidesThanProducts && limitGreaterThanSlide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }
      if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
        initialIndex = 0;
      } else if (productsPerSlide === '3' && productsAvailable) {
        initialIndex = 1;
      } else if (productsPerSlide === '5' && productsAvailable) {
        initialIndex = 2;
      } else if (productsPerSlide === '7' && productsAvailable) {
        initialIndex = 3;
      }
      if (window.PXUTheme.media_queries.medium.matches) {
        cellAlign = 'center';
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;
        $productSlider.parents('.even-num-slides').removeClass('even-num-slides');
      }
      $productSlider.flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable,
        cellAlign,
        prevNextButtons: prevNext,
        wrapAround,
        contain: true,
        freeScroll: true,
        initialIndex
      });
    });
  },
  initializeQuantityBox() {
    $('body').on('click', '.js-change-quantity', e => {
      const $this = $(e.currentTarget);
      const $input = $this.siblings('input');
      const val = parseInt($input.val(), 10);
      let valMax = 100000000000000000000000000000;
      const valMin = $input.attr('min') || 0;
      if ($input.attr('max') != null) {
        valMax = $input.attr('max');
      }
      if (isNaN(val) || val < valMin) {
        $input.val(valMin);
      }
      if (val > valMax) {
        $input.val(valMax);
      }
      if ($this.data('func') === 'plus') {
        if (val < valMax) $input.val(val + 1);
      } else {
        if (val > valMin) $input.val(val - 1);
        if ($this.parents('.cart_item').length) {
          if (val - 1 === 0) {
            $this.closest('.cart_item').addClass('animated fadeOutUp');
          }
        }
      }
      $input.trigger('change');
    });
  },
  unload($target) {
    const $slider = $target.find('.products-slider');
    $slider.flickity('destroy');
    $('body').off('click', '.js-change-quantity');
  }
};
